import Product from "../../../../../../@types/Product";
import Batteries from "../../Shared/Batteries";


const LithiumBattery105AH = Batteries[0];
const LithiumBattery160AH = Batteries[2];

const ChassisBatteryConfigs: Product[] = [
    {
        id: 1,
        name: 'ECO Lithium Battery 105AH',
        sku: '27-044-1',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/batteries/eco-lithium-105ah.png`,
        price: 1500,
        retailPrice: 0.00,
        linkedProducts: [LithiumBattery105AH],
        
    },
    {
        id: 2,
        name: 'ECO Lithium Battery GEN3 160AH',
        sku: '27-044-2',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/batteries/eco-lithium-160ah.png`,
        price: 2400,
        retailPrice: 1000.00,
        linkedProducts: [LithiumBattery160AH]
    },
]


const ChassisBatteryConfigsPreassembly: Product[] = [
    {
        id: 1,
        name: 'ECO Lithium Battery 105AH',
        sku: '27-034',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/batteries/eco-lithium-105ah.png`,
        price: 1500,
        retailPrice: 0.00,
        linkedProducts: [LithiumBattery105AH],
        
    },
    {
        id: 2,
        name: 'ECO Lithium Battery GEN3 160AH',
        sku: '27-035',
        img: `${process.env.PUBLIC_URL}/cart-part-images/xseries/batteries/eco-lithium-160ah.png`,
        price: 2400,
        retailPrice: 1000.00,
        linkedProducts: [LithiumBattery160AH]
    },
]
export { ChassisBatteryConfigs, ChassisBatteryConfigsPreassembly };